import { Link } from "react-router-dom";
import Header from "./Header";
import { useTranslation } from "react-i18next";
import { UserContext } from "../contexts/UserContext";
import i18n from "../translate/i18n";
import React, { useState, useContext, useEffect } from "react";


const PageNotFound = () => {
  const { t } = useTranslation();

  const [i18nextLngs, seti18nextLngs] = useState(
    localStorage.getItem("i18nextLng") || "en" || "et" || "fi"
  );
  const { i18nextLng } = useContext(UserContext);
  useEffect(() => {
    if (i18nextLng === "en") {
      i18n.changeLanguage(i18nextLngs);
      document.documentElement.lang = i18nextLngs;
      localStorage.setItem("i18nextLng", i18nextLngs);
    }
  }, [i18nextLng]);
  
  
  return (
    <>
      <div className="page-head-none">
        <Header />
      </div>

      <div className="page-not-found">
        <div className="not-found-img-wrap">
          <img
            src={require("../assests/not-found.webp")}
            alt="page-not-found"
            className="page-img-light"
          />
          <img
            src={require("../assests/not-found-dark.webp")}
            alt="page-not-found"
            className="page-img-dark"
          />
        </div>
        <h3 className="not-found-title">{t("PageNotFound")}</h3>
        <p className="not-found-content">{t("missing")}</p>
        <Link to="/" className="not-found-btn">
          {t("GoBackHomePage")}
        </Link>
      </div>
    </>
  );
};

export default PageNotFound;
